module.exports = __webpack_public_path__ + "static/media/twitter.978f4ba9.svg";